import { render, staticRenderFns } from "./closed.vue?vue&type=template&id=6a916de2&scoped=true&"
import script from "./closed.vue?vue&type=script&lang=ts&"
export * from "./closed.vue?vue&type=script&lang=ts&"
import style0 from "./closed.vue?vue&type=style&index=0&id=6a916de2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a916de2",
  null
  
)

export default component.exports